export enum AvitoStatus {
    OnConfirmation = "OnConfirmation",
    ReadyToShip = "ReadyToShip",
    InTransit = "InTransit",
    Canceled = "Canceled",
    Delivered = "Delivered",
    OnReturn = "OnReturn",
    InDispute = "InDispute",
    Closed = "Closed",
    ClosedAfterReturn = "ClosedAfterReturn",
}